window.GContacts = {
	
	connect : function() {
		MyFacture.post("gcontacts_prefs&action=connect", null,  function(data) {
			if(data != null) {
				var options = {
					resizable	: false,
					noclose		: true,
					title		: "Connection à Google",
					buttons		: {
						"Annuler": function(){
							MyFacture.post("gcontacts_prefs&action=disconnect", null, null, "json");
							$(this).dialog("close");
						},
						"Valider": function(){
							window.location = data.auth_url;
						}
					}
				};
				MyWindow.alert("Vous allez être redirigé vers la page d'authentification de Google.<br/><br /> Acceptez l'application pour synchroniser vos contacts.", options);
			}
		}, "json");
		
		$(document).keyup(function(e) {
			if (e.keyCode == 27) { 
				MyFacture.post("gcontacts_prefs&action=disconnect", null, null, "json");
			}
		});
	},
	
	confirmConnect : function() {
		var options = {
			resizable	: false,
			noclose		: true,
			title		: "Connection dropbox",
			buttons		: {
				"Valider": function(){ $(this).dialog("close");	}
			}
		};
		MyWindow.alert("Vous êtes maintenant connecté à Google Contacts.<br/><br/>Vous pouvez dès à présent synchroniser vos contacts.", options);
	},
	
	disconnect : function() {
		MyFacture.post("gcontacts_prefs&action=disconnect", null, function(data) {
			$('#status').text(data.status);
		}, "json");
	}
	
};